import './styles.css';
import { initAuth, requireClinicSession } from './auth';
import { renderLanding } from './landing';
import { renderApp } from './app';

const root = document.getElementById('root');
if (!root) {
  throw new Error('#root missing');
}

if (location.pathname.startsWith('/app')) {
  const ok = await requireClinicSession();
  if (!ok) {
    root.innerHTML = '<p class="boot">Redirigiendo a la cuenta de la clínica…</p>';
  } else {
    await renderApp(root);
  }
} else {
  await renderLanding(root);
  void initAuth().then(() => renderLanding(root));
}
